import createAccount from "./createAccount";

export default {
	createAccount,
};
